import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import PhoneMockup from './PhoneMockup';
import { useScrollAnimation, fadeInUpVariants, staggerContainerVariants } from '../hooks/useScrollAnimation';
import video from '../assets/video.mp4';
import video2 from '../assets/video2.mp4';
const HeroContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: env(safe-area-inset-top);
  flex: 1;
`;

const BackgroundGradient = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to bottom, #000000 7%, #6832DC 50%, #341A78 100%, black 100%, #000000 100%); 
  z-index: 0;
  opacity: 0;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 1200px;
  z-index: 1;
  padding: 0 20px;
  height: 100vh;
  position: relative;
  overflow: hidden;
  
  @media (max-width: 768px) {
    height: auto;
    min-height: 800px !important;
    padding: 60px 15px;
  }
`;

const HeaderSection = styled.div`
  position: absolute;
  top: 2%;
  left: 0;
  right: 0;
  text-align: center;
  z-index: 3;
  padding: 0 20px;
`;

const Title = styled(motion.h1)`
  font-size: 82px;
  font-family: "Black Han Sans", sans-serif;
  letter-spacing: -0.02em;
  text-transform: none;
  font-weight: 900;
  margin-bottom: 10px;
  text-align: center;
  line-height: 1.1;
  
  .gradient-text {
    background: linear-gradient(
      120deg,
      #ffffff 0%,
      #ff6ad5 25%,
      #c659ff 50%,
      #ff36be 75%,
      #ffffff 100%
    );
    background-size: 400% 100%;
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: gradientFlow 6s ease infinite;
    text-shadow: 0 0 30px rgba(255, 106, 213, 0.3);
  }
  
  .white-text {
    color: white;
    text-shadow: 
      0 0 20px rgba(255, 255, 255, 0.2),
      0 0 40px rgba(104, 50, 220, 0.4);
  }
  
  &.subtitle {
    font-size: 48px;
    margin-top: -10px;
  }
  
  @media (max-width: 768px) {
    font-size: 62px;
    
    &.subtitle {
      font-size: 36px;
    }
  }
  
  @media (max-width: 480px) {
    font-size: 54px;
    
    &.subtitle {
      font-size: 32px;
    }
  }
`;

const Subtitle = styled(motion.h2)`
  font-size: 24px;
  font-weight: 600;
  color: #DCB9FF;
  font-family: "Black Han Sans", sans-serif;
  font-weight: 400;
  font-style: normal;
  text-align: center;
  max-width: 500px;
  margin: 0 auto;
  margin-bottom: 30px;
  letter-spacing: -0.01em;
  
  .gradient-text {
    background: linear-gradient(
      120deg,
      #ffffff 0%,
      #ff6ad5 25%,
      #c659ff 50%,
      #ff36be 75%,
      #ffffff 100%
    );
    background-size: 400% 100%;
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  
  @media (max-width: 768px) {
    font-size: 18px;
    margin-bottom: 20px;
  }
`;

const PhoneContainer = styled(motion.div)`
  position: absolute;
  // top: 50%;
  // left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  // margin-top: 60px;
  
  @media (max-width: 768px) {
  top:8%;
    transform: translate(-50%, -50%);
    // height: 1000px !important;
  }
`;

const PhoneMockupContainer = styled(motion.div)`
  position: relative;
  top: 140px;
  width: 320px;
  margin: 0 auto;
  
  @media (max-width: 768px) {
    top: 120px;
  }
`;

const ButtonContainer = styled.div`
  position: absolute;
  bottom: 10%;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  z-index: 3;
  
  @media (max-width: 768px) {
    bottom: 8%;
  }
`;

const DownloadButton = styled(motion.button)`
  background: linear-gradient(to right, #8000FF, #AA52FF);
  color: white;
  padding: 18px 42px;
  border-radius: 50px;
  font-size: 18px;
  font-weight: 600;
  box-shadow: 0 10px 30px rgba(128, 0, 255, 0.4);
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  transition: all 0.3s ease;
  overflow: hidden;
  position: relative;
  
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: 0.5s;
  }
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 15px 35px rgba(128, 0, 255, 0.5);
    
    &:before {
      left: 100%;
    }
  }
  
  @media (max-width: 768px) {
    padding: 16px 36px;
    font-size: 16px;
  }
`;

const AppStoreIcon = styled.img`
  width: 24px;
  height: 24px;
  filter: brightness(1.2);
`;

const LightSpot = styled.div`
  position: absolute;
  width: 800px;
  height: 800px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(143, 0, 255, 0.15) 0%, rgba(143, 0, 255, 0) 70%);
  z-index: 0;
  pointer-events: none;
  
  &.top-left {
    top: -400px;
    left: -400px;
  }
  
  &.bottom-right {
    bottom: -400px;
    right: -400px;
  }
`;

const FloatingParticle = styled.div`
  position: absolute;
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  border-radius: 50%;
  background: ${props => props.color};
  opacity: ${props => props.opacity};
  z-index: 1;
  filter: blur(${props => props.blur}px);
  animation: float ${props => props.duration}s ease-in-out infinite;
  top: ${props => props.top}%;
  left: ${props => props.left}%;
  
  @keyframes float {
    0%, 100% {
      transform: translateY(0) translateX(0);
    }
    50% {
      transform: translateY(${props => props.floatDistance}px) translateX(${props => props.floatDistance/2}px);
    }
  }
`;

const ScrollArrow = styled(motion.div)`
  position: absolute;
  bottom: -100px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: white;
  z-index: 1000;
  @media (max-width: 768px) {
    bottom: 5%;
  }
`;

const ArrowIcon = styled.div`
  width: 20px;
  height: 20px;
  border-right: 3px solid #A239FF;
  border-bottom: 3px solid #A239FF;
  transform: rotate(45deg);
  margin-top: 10px;
  filter: drop-shadow(0 0 8px rgba(162, 57, 255, 0.8));
  transition: all 0.3s ease;
  
  &:hover {
    border-right: 3px solid #DCB9FF;
    border-bottom: 3px solid #DCB9FF;
    filter: drop-shadow(0 0 12px rgba(220, 185, 255, 0.9));
  }
`;

const ScrollText = styled.p`
  font-size: 16px;
  font-weight: 500;
  color: #DCB9FF;
  margin-bottom: 8px;
  text-shadow: 0 0 5px rgba(220, 185, 255, 0.5);
`;

const PawPrintDecoration = styled(motion.span)`
  font-size: 18px;
  margin: 0 8px;
  display: inline-block;
  color: #ff6ad5;
`;

const CatWhiskers = styled.div`
  position: relative;
  display: inline-block;
  
  &:before, &:after {
    content: '';
    position: absolute;
    width: 50px;
    height: 2px;
    background: linear-gradient(90deg, transparent, rgba(255, 106, 213, 0.5));
    top: 50%;
  }
  
  &:before {
    left: -60px;
    transform: rotate(-10deg);
  }
  
  &:after {
    right: -60px;
    transform: rotate(10deg);
  }
`;

const CatEyes = styled(motion.div)`
  position: absolute;
  width: 100%;
  top: -30px;
  left: 0;
  display: flex;
  justify-content: center;
  gap: 100px;
  
  .eye {
    width: 12px;
    height: 12px;
    background: linear-gradient(120deg, #ff6ad5, #c659ff);
    border-radius: 50%;
    position: relative;
    
    &:before {
      content: '';
      position: absolute;
      width: 6px;
      height: 20px;
      background: linear-gradient(to bottom, #ff6ad5, #c659ff);
      border-radius: 6px;
      top: -4px;
      left: 3px;
    }
  }
`;

const HeroSection = () => {
  const phoneAnimationDelay = 0.3;
  const bgAnimationDelay = 1.2;
  const animationDuration = 1.0;

  const particles = [
    { size: 8, color: '#8000FF', opacity: 0.6, blur: 3, duration: 7, top: 20, left: 20, floatDistance: 20 },
    { size: 15, color: '#B69DFF', opacity: 0.4, blur: 4, duration: 9, top: 70, left: 80, floatDistance: -30 },
    { size: 10, color: '#AA52FF', opacity: 0.5, blur: 2, duration: 8, top: 30, left: 85, floatDistance: 25 },
    { size: 12, color: '#6A00D1', opacity: 0.3, blur: 5, duration: 6, top: 80, left: 15, floatDistance: -20 },
    { size: 6, color: '#8000FF', opacity: 0.7, blur: 1, duration: 10, top: 40, left: 40, floatDistance: 15 },
  ];

  return (
    <HeroContainer>
      <BackgroundGradient
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ 
          duration: animationDuration * 1.5,
          delay: bgAnimationDelay,
          ease: "easeInOut" 
        }}
      />
      
      <LightSpot className="top-left" />
      <LightSpot className="bottom-right" />
      
      {particles.map((particle, index) => (
        <FloatingParticle key={index} {...particle} />
      ))}
      
      <ContentWrapper>
        <HeaderSection>
          <Title>
            <CatEyes
              animate={{
                scale: [1, 1.05, 1],
              }}
              transition={{
                duration: 2,
                repeat: Infinity,
                repeatType: "reverse"
              }}
            >
              <div className="eye"></div>
              <div className="eye"></div>
            </CatEyes>
            <motion.div
              initial={{ opacity: 0, y: -30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ 
                duration: 0.8, 
                delay: 0.2,
                type: "spring",
                stiffness: 100,
                damping: 12
              }}
            >
              <PawPrintDecoration
                animate={{ rotate: [0, 15, 0] }}
                transition={{ duration: 2, repeat: Infinity }}
              >
                🐾
              </PawPrintDecoration>
              <span className="gradient-text">Relax</span>
              <PawPrintDecoration
                animate={{ rotate: [0, -15, 0] }}
                transition={{ duration: 2, repeat: Infinity }}
              >
                🐾
              </PawPrintDecoration>
            </motion.div>
          </Title>
          
          <Title className="subtitle">
            <CatWhiskers>
              <motion.div
                initial={{ opacity: 0, y: -30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ 
                  duration: 0.8, 
                  delay: 0.4,
                  type: "spring",
                  stiffness: 100,
                  damping: 12
                }}
              >
                <span className="gradient-text">Chef's</span>{" "}
                <span className="white-text">got this</span>
              </motion.div>
            </CatWhiskers>
          </Title>
        </HeaderSection>
        
        <PhoneMockupContainer>
          <PhoneMockup 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ 
              duration: 0.8,
              delay: 0.6,
              type: "spring",
              stiffness: 100,
              damping: 15
            }}
            videoSrc={video}
            videoSrc2={video2}
          />
        </PhoneMockupContainer>
        
   
        {/* <ButtonContainer>
          <DownloadButton
            variants={fadeInUpVariants}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.8 }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.97 }}
          >
            <AppStoreIcon src="/images/app-store-badge.png" alt="App Store" />
            Download on App Store
          </DownloadButton>
        </ButtonContainer> */}
      </ContentWrapper>
      <ScrollArrow
        initial={{ opacity: 0 }}
        animate={{ 
          opacity: 1,
          y: [0, 10, 0],
        }}
        transition={{ 
          delay: 3.0,
          y: { 
            repeat: Infinity,
            duration: 1.5,
            ease: "easeInOut"
          }
        }}
      >
        <ArrowIcon />
      </ScrollArrow>
        
    </HeroContainer>
  );
};

export default HeroSection; 